import { onBeforeUnmount } from 'vue';
/* 获取最外层盒子 */
export function useBigScreen(screenRef) {
    /* 根据浏览器大小推断缩放比例 */
    const getScale = (width = 1920, height = 1080) => {
        let ww = window.innerWidth / width;
        let wh = window.innerHeight / height;
        return ww < wh ? ww : wh;
    };
    /* 浏览器监听 resize 事件 */
    const resize = () => {
        if (screenRef.value) {
            screenRef.value.style.transform = `scale(${getScale()}) translate(-50%, -50%)`;
        }
    };

    if (screenRef.value) {
        screenRef.value.style.transform = `scale(${getScale()}) translate(-50%, -50%)`;
        /* 初始宽高 */
        screenRef.value.style.width = `1920px`;
        screenRef.value.style.height = `1080px`;
    }
    window.addEventListener('resize', resize);

    /* 销毁时触发 */
    onBeforeUnmount(() => {
        window.removeEventListener('resize', resize);
    });
}
